import { DateTime } from '../../../DateTime'
import { TableColumn } from '../../../Table'

import { DeleteButton } from './styles'

export const columns = (
  deleteFile: (uid: number) => void
): TableColumn<{
  file: File
  uid: number
}>[] => [
  {
    align: 'left',
    title: 'Filename',
    render: ({ file, uid }) => (
      <>
        <DeleteButton onClick={() => deleteFile(uid)}>
          <span>Delete</span>
        </DeleteButton>
        {file.name}
      </>
    )
  },
  {
    width: '180px',
    align: 'center',
    title: 'Last Modified Date',
    render: ({ file }) => <DateTime withTime date={file.lastModified} />
  }
]
